/** Значение style в объекте стиля */
export default class StyleValue {
  constructor({ alignment, border, fill, font }) {
    this.alignment = alignment;
    this.border = border;
    this.fill = fill;
    this.font = font;
  }

  /**
   * @param {unknown} obj
   * @return {StyleValue}
   */
  static fromJSON(obj) {
    if (!obj) return undefined;
    if (typeof obj !== 'object') throw new Error('not an object');
    return new StyleValue(obj);
  }
}
